export enum ConcessionType {
  ALTROCONSUMO = 'ALTROCONSUMO',
  BENEFITHUB = 'BENEFITHUB',
  PICKABU = 'PICKABU',
}
